export const CONTENT_AGREEMENT_FILE_TYPE = 'content_agreement';
export const CONTENT_AGREEMENT_CDN_PATH = 'activations/content-rights';
export const CONTENT_AGREEMENT_FILE_RESOURCE_NAME = 'activation-content-rights';
export const BRAND_ASSET_FILE_TYPE = 'brand_asset';
export const BRAND_ASSET_CDN_PATH = 'activations/brand-assets';
export const BRAND_ASSET_FILE_RESOURCE_NAME = 'activation-brand-asset';
export const FILE_UPLOAD_TYPE = 'file_upload';
export const CONTENT_APPROVAL_FILE_TYPE = 'content_approval';
export const CONTENT_APPROVAL_CDN_PATH = 'activations/content-approval';
export const CONTENT_METRIC_SCREENSHOT_FILE_TYPE = 'content_metric_screenshot';
export const CONTENT_METRIC_SCREENSHOT_CDN_PATH = 'content-metric-screenshots';
export const FILE_CDN_PATH_MAP = {
    [CONTENT_AGREEMENT_FILE_TYPE]: CONTENT_AGREEMENT_CDN_PATH,
    [BRAND_ASSET_FILE_TYPE]: BRAND_ASSET_CDN_PATH,
    [CONTENT_APPROVAL_FILE_TYPE]: CONTENT_APPROVAL_CDN_PATH,
    [CONTENT_METRIC_SCREENSHOT_FILE_TYPE]: CONTENT_METRIC_SCREENSHOT_CDN_PATH
};
